import { render, staticRenderFns } from "./PopupByCountry.vue?vue&type=template&id=055ad18b&"
import script from "./PopupByCountry.vue?vue&type=script&lang=js&"
export * from "./PopupByCountry.vue?vue&type=script&lang=js&"
import style0 from "./PopupByCountry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports